import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

import { ApiCategoryList } from 'idt-ecommerce-api/_api/api-catalog/api-categories/api-categories.models';
import { ApiCategoriesService } from 'idt-ecommerce-api/_api/api-catalog/api-categories/api-categories.service';
import { EcommerceContext } from 'idt-ecommerce-api/context/context.models';
import { ContextService } from 'idt-ecommerce-api/context/context.service';

import { Category } from './categories.models';
import { CategoriesModelsTransformer } from './categories.models.transformer';


@Injectable()
export class CategoriesService {

  constructor(
    private readonly apiCategoriesService: ApiCategoriesService,
    private readonly contextService: ContextService
  ) { }

  public categories(
    storeId?: string,
    catalogId?: string,
    hasToFilter: boolean = false,
    currentLanguage: string | null = null
  ): Observable<Category[]> {
    return this.contextService.getContext$().pipe(
      first(),
      switchMap((context: EcommerceContext) => {
        return this.apiCategoriesService.categories(
          storeId || context.store.id,
          catalogId || context.currentCatalogId,
          currentLanguage || context.currentLanguage.id,
          true
        ).pipe(
          map((categoryList: ApiCategoryList): Category[] => CategoriesModelsTransformer.categoriesFromApi(categoryList, context, hasToFilter))
        );
      })
    );
  }

}
